import {
  ENCOUNTERS_HISTORY_INITIALIZED,
  ENCOUNTERS_HISTORY_INITIALIZE,
  ENCOUNTERS_HISTORY_UPDATE,
  ENCOUNTERS_HISTORY_UPDATE_SUCCESS,
  ENCOUNTERS_HISTORY_UPDATE_ERROR,
  ENCOUNTERS_HISTORY_EDIT,
  ENCOUNTERS_HISTORY_CANCEL
} from './actions.js'

const defaultState = {
  loading: false,
  data: [],
  edit: {}
}

export default function reducer (state = defaultState, action) {
  switch (action.type) {
    case ENCOUNTERS_HISTORY_INITIALIZE:
      return {
        ...state,
        loading: true
      }
    case ENCOUNTERS_HISTORY_INITIALIZED:
      return {
        ...state,
        loading: false,
        data: action.data,
        activity: action.activity
      }
    case ENCOUNTERS_HISTORY_UPDATE:
      return state
    case ENCOUNTERS_HISTORY_UPDATE_SUCCESS:
      return {
        ...state,
        data: state.data.map(item => {
          if (item.id === action.encounter.id) {
            return action.encounter
          }
          return item
        }),
        edit: {
          ...state.edit,
          [action.encounter.id]: false
        }
      }
    case ENCOUNTERS_HISTORY_UPDATE_ERROR:
      return state
    case ENCOUNTERS_HISTORY_EDIT:
      return {
        ...state,
        edit: {
          ...state.edit,
          [action.encounter.id]: true
        }
      }
    case ENCOUNTERS_HISTORY_CANCEL:
      return {
        ...state,
        edit: {
          ...state.edit,
          [action.encounter.id]: false
        }
      }
    default:
      return state
  }
}
